import { createAction } from "@reduxjs/toolkit";
import type { AdminStudioListItem } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveAdminStudio = createApiThunk<AdminStudioListItem, string>(
  "admin/studio/retrieve",
  async (id, { extra: { adminRepository } }) => {
    return adminRepository!.getStudioById(id);
  },
);

export const resetRetrieveAdminStudio = createAction("admin/studio/resetRetrieve");
